import { Images } from "@/constants/images"
import Image from "next/image"
import Link from "next/link"
import type { SectionData } from "../types/new"
import { NewsItemCard } from "./NewsItemCard"

export function NewsSection({ data }: { data: SectionData }) {
  const { title, slug, main, highlights = [], bullets = [], postsData } = data
  return (
    <section className="bg-white mb-[18px]">
      <header className="h-[44px] mb-[10px] flex items-center gap-[18px] bg-[#F5F5F5] pl-[10px] pr-[20px]">
        <Image src={Images.subMenuLogo} alt={title} width={56} height={20} />
        <Link
          href={`/category/${slug}`}
          className="sm:text-lg sm:leading-[27.9px] text-base leading-[24.8px] sm:font-bold font-semibold text-[#25262b] hover:text-[#1EAD46]"
        >
          {title}
        </Link>
      </header>

      {/* Desktop: lưới 2 cột; Mobile: 1 cột */}
      <div className="flex flex-col md:flex-row md:border-b md:border-dashed md:border-black/20">
        {/* Cột trái: tin lớn */}
        <div className="w-full md:w-1/2 md:border-r md:py-2 md:pr-2 md:border-dashed md:border-black/20">
          {main && <NewsItemCard variant="main" article={main} postData={postsData?.get(main.id)} />}
        </div>

        {/* Cột phải: danh sách ảnh nhỏ */}
        <div className="w-full md:w-1/2">
          <ul className="space-y-[5px] p-0 py-2 md:p-2 md:mb-0 mb-[16px]">
            {highlights.slice(0, 8).map(a => (
              <NewsItemCard
                key={a.id}
                variant="small"
                article={a}
                className="md:mb-0 mb-[1px]"
                postData={postsData?.get(a.id)}
              />
            ))}
          </ul>
        </div>
      </div>

      {/* Danh sách bullet bên dưới (nếu có) */}
      {bullets.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-3">
          {bullets.slice(0, 3).map(a => (
            <NewsItemCard
              className="p-2"
              key={a.id}
              variant="bullet"
              article={a}
              showTime
              postData={postsData?.get(a.id)}
            />
          ))}
        </div>
      )}
    </section>
  )
}
